// TD Draft 2026-09-28 D09/S14 + P09 — Bezug-Seiten: geöffnete Detail-Akkordeons bleiben beim Variantenwechsel offen,
// die neue „Passt auf“-Zeile wird für Screenreader angesagt.
// Prestige ersetzt „liquid“-Blöcke bei jedem Variantenwechsel (product-rerender, allow-partial-rerender) durch frisch
// gerendertes HTML; ohne diese Hilfe klappten geöffnete Punkte (Material, Pflegehinweise …) nach jeder Auswahl zu.
// Nur im Cover-Template geladen (Sektion td_g4_cover_assets → snippets/td-g4-covers-assets.liquid); der Guard verhindert
// doppelte Listener, falls das Script ein zweites Mal eingebunden wird.
(() => {
  if (window.tdG4CoverAccordionBound) return;
  window.tdG4CoverAccordionBound = true;

  const openLabels = new Set();

  const labelOf = (details) => {
    if (!details || !details.closest('.td-d09-cover-accordion')) return '';
    const label = details.querySelector('.td-meta-accordion__title-label');
    return label ? label.textContent.trim() : '';
  };

  // toggle does not bubble → capture phase on document
  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement)) return;
    const label = labelOf(details);
    if (!label) return;
    if (details.open && details.getAttribute('aria-expanded') !== 'false') {
      openLabels.add(label);
    } else {
      openLabels.delete(label);
    }
  }, true);

  const restore = () => {
    if (!openLabels.size) return;
    document.querySelectorAll('.td-d09-cover-accordion accordion-disclosure').forEach((disclosure) => {
      const details = disclosure.querySelector('details');
      if (!details || details.open || !openLabels.has(labelOf(details))) return;
      if (typeof disclosure.toggle === 'function') {
        disclosure.toggle(true, false); // open instantly, no animation
      } else {
        details.open = true;
        details.setAttribute('aria-expanded', 'true');
      }
    });
  };

  // TD Draft 2026-09-28 P09 — Screenreader: Prestige ersetzt den „Passt auf“-Block bei jedem Variantenwechsel, ohne dass
  // das angesagt wird. Die neue Zeile wird deshalb in die aria-live-Region aus td-g4-covers-assets kopiert
  // (nur auf der deutschen Storefront vorhanden). Gibt es die Kombination nicht, bleibt die Region leer.
  const fitText = () => {
    const fit = document.querySelector('.shopify-section--main-product .td-p09-fit__text'); // nicht Quick-Buy
    return fit ? fit.textContent.replace(/\s+/g, ' ').trim() : '';
  };
  let lastFitText = fitText(); // Startzustand nicht ansagen (Script ist defer, DOM steht)
  const announceFit = () => {
    const live = document.querySelector('[data-td-g4-fit-live]');
    if (!live) return;
    const text = fitText();
    if (text === lastFitText) return;
    lastFitText = text;
    live.textContent = text;
  };

  // variant:change is dispatched right after product:rerender has swapped the blocks
  document.addEventListener('variant:change', () => requestAnimationFrame(() => {
    restore();
    announceFit();
  }));
})();
